import { IsNotEmpty, IsArray, IsString, MinLength, MaxLength, IsISO8601 } from 'class-validator';

export class SchedulingEventsQueryDTO {

    @IsNotEmpty()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    ids: Array<string>;

    @IsNotEmpty()
    @IsISO8601()
    from: string;

    @IsNotEmpty()
    @IsISO8601()
    to: string;

}
